<template>
  <div class="mainMenus"> 
 <!-- <el-container> -->
  <div class="Contentframe">
  <!-- <el-aside width="150px" class="leftmenu"> -->
 <!-- <i class="el-icon-s-unfold" @click="visible = true"></i> -->
    <div class="leftmenu">
 
<span class="firstsubMenu">{{info.info_NAME}}</span>
<el-divider></el-divider>
    <router-link :to="{path:infos.router, query:{htmlpath:infos.htmlPath,infoID:info.info_ID,active:infos.info_CLASS_ID,styles: [index + ''],t: Date.now()}}"  :index="index+''" v-for="(infos,index) in info.info_classes" :key="index" 
    :class="{active : active == infos.info_CLASS_ID}"   @click.native="selected(infos.info_CLASS_ID)">
    <span class="submenu">
    {{infos.info_CLASS_NAME}}
     <el-divider></el-divider>
    </span>
    </router-link>
  <!-- </div> -->
  <!-- </el-aside> -->
  </div>

 <div class="rightContent">

  <!-- <div class="menus"  >     -->
    <div class="menu"  v-for="(menus,index) in InfoMenusList" :key="index" @click="getMenus(menus)" :class="{'menu_w':menusType==2,'menu_h':menusType==1,'menu_s':menusType==0}"  >
        <div class="menus_images"><img :src="imagepath+menus.filePath"></div>
   <div class="menus_Name">

    <el-tooltip :content="menus.info_NAME"  placement="bottom" effect="light" :open-delay="750"	>
  <span class="span3">{{menus.info_NAME}}</span>
</el-tooltip>

   
   <!-- </div> -->
    </div>
    </div>

 </div>
 <!-- </el-container> -->
   </div>



     </div>
</template>

<script>
import LeftMenus from './../../LeftMenus.vue'
export default {
created(){
  this.getInfoClassId()
},
data(){
  return{
    menusType:'',
    imagepath:'',
    InfoMenusList:[],
     info:{},
     active:''
  }
},
methods:{
  getInfoClassId(){
    // alert(this.$route.query.htmlpath)
    this.active=this.$route.query.active
           this.axios.post("/info/getInfo?infoID="+this.$route.query.infoID)
    .then(resp => { 
                      if(resp.data.status == 1) {      
                        this.info=resp.data.result[0]    
                        resp.data.result[0].info_classes.forEach(element => {
                          if(element.info_CLASS_ID==this.$route.query.active){
                           this.menusType=element.menusType
                          }
                        });
                                                                 
                                   console.log(resp.data.result[0])           
                                }else {
                                   alert("拿取数据失败")                                 
                                }
                            })
                            .catch((err) => {
                               // alert("出错了")
                                console.log(err)
                            })     
     this.imagepath=this.$imagepath
     this.axios.post("/info/getMenusById","INFO_CLASSs_ID="+this.$route.query.htmlpath)
          .then(resp => { 
                      if(resp.data.status == 1) {    
                         this.InfoMenusList=resp.data.result  
                         console.log( resp.data.result)                                                            
                                }else {
                                    alert("失败")
                                   this.$message.error(resp.result.message)                               
                                }
                            })
                            .catch((err) => {
                               // alert("出错了")
                                console.log(err)
                            }) 
  }, flishCom(){
    this.$router.go(0)
  },
  getMenus(data){
    console.log(data)
    this.$router.push({  //核心语句
        path:'/communications',   //跳转的路径
        query:{           //路由传参时push和query搭配使用 ，作用时传递参数
          htmlpath:data.htmlPath,
          infoID:this.info.info_ID,
          active:this.active,
          threeMenus:data.info_ID,
          styles:this.$route.query.styles
        }
      })
  },
  selected(name){
   this.active = name;
}
}
}
</script >

<style scoped>

.Contentframe{
  width: 68%;
  margin: auto;
  display: flex;
}

.mainMenus{
  width: 100%;
  height: 100%;
  margin: auto;
  display: flex;
}
.mainMenus{
  padding-left: 0px;
}
.menus{
  width:100%;
  margin: auto;
  display: flex;
  /* justify-content: space-between; */
  flex-flow: row wrap;
   flex-wrap: wrap; 
   }
.menus:after {content: ""; width: 389.06px; }

.menuold{
  width: 250px;
  height: 300px;
  margin: 10px;
}

.menu{
  width: 200px;
  height: 250px;
  margin: 10px;
}
.menu_w{
  width: 200px;
  height: 150px;
  margin: 10px;
}
.menu_h{
  width: 200px;
  height: 250px;
  margin: 10px;
}

.menu_s{
  width: 200px;
  height: 200px;
  margin: 10px;
}




.menus_images{
  width: 80%;
  height: 80%;

}
.leftAside{
    position: fixed;
  }
.menus_Name
{
   height: 42px;
  margin-top: 10px;
}
img{
  width: 100%;
  height: 100%;
  overflow:hidden;
}
.span3{
  height: 42px;
  width:160px;
  font-size: 12px;
  /* line-height: 10px; */
  /* z-index: 2; */
 
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    word-wrap: break-word;
    display: -webkit-box;
    overflow: hidden;
    letter-spacing: 1px;
    white-space: normal;
    word-break: break-all;     

  /* word-wrap: break-word; */
    
}
.active {
     border-bottom: 4px solid #0065bd;
 }

 .leftmenu
 {
   padding-left:15px;
     background:rgb(196, 196, 233,0.6);
   color:black;
   margin-top: 40px;
   margin-right: 20px;
   height:400px;
   width:20%;
   padding: 20px;
 }

 .firstmenu
 {
   font-weight: 500;
   font-size: 18px;
   padding-top: 10px;
   border-left: 8px solid #ffd04b;
   
 }

 
 .firstsubMenu
 {
   width: 100%;
    height: 40px;
    line-height: 40px;
    color: #010544;
    padding: 0 10px;
    font-size: 18px;
    font-weight: 600;

     border-left: 6px solid #0065bd;
    /* border-bottom: 1px solid #ecebeb; */
}

  .submenu
 {
   font-weight: 400;
   font-size: 16px;
    margin-left: 10px;
    color: black;
    /* border-bottom: 2px solid #ecebeb */
   
 }

 .submenunew
 {
    width: 100%;
    font-size: 16px;
    line-height: 16px;
    color: #010544;
 

    border-width: 60px;
   
    border-style: solid;
    border-color: transparent transparent transparent #E362D5;
    margin-left:6px;
    padding: 1px 1px;
    display: flex;
    align-items: center;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.1s ease-in-out;
 }

 .rightContent{
  width: 80%;
  margin-left:50px;
    width:100%;
  margin: auto;
  display: flex;
  /* justify-content: space-between; */
  flex-flow: row wrap;
   flex-wrap: wrap; 
   margin-top: 30px;
   margin-left: 50px;

}

  .router-link-active {     
   text-decoration: none;
   border-block-color: 2px;
 }
 
a{
  color:white;
  text-decoration: none;
}
/* ul li{
  text-decoration: none;
} */
.con {
    display: true;
    position: relative;
    bottom: 47px;
    left: 50%;
    z-index: 1000;
    margin-left: -40px;
    margin-top: 60px;
    width: 80px;
}

</style>


// WEBPACK FOOTER //
// src/components/work/navigation/majorsetup/ThreeMenus.vue